exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#passwordRecoveryContainer{background-color:#fff;max-width:450px;margin:5px;padding:15px 10px 30px;border-radius:15px;-ms-flex-preferred-size:auto!important}#passwordRecoveryContainer #submit{padding-left:40px;padding-right:40px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/stylus-loader!./src/containers/password-recovery/password-recovery.styl
// module id = 97
// module chunks = 1